var _rect, _rect2, _rect3, _rect4, _rect5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutline3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.416667,
    y: 0.416667,
    width: 29.1667,
    height: 32.5,
    rx: 2.91667,
    stroke: "#DEDDE6",
    strokeWidth: 0.833333
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16699,
    y: 5.83325,
    width: 11.6667,
    height: 2.5,
    rx: 0.833333,
    fill: "#ACAAB7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16699,
    y: 12.4999,
    width: 7.5,
    height: 2.5,
    rx: 0.833333,
    fill: "#ACAAB7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16699,
    y: 25.8333,
    width: 15,
    height: 2.5,
    rx: 0.833333,
    fill: "#ACAAB7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16699,
    y: 19.1666,
    width: 21.6667,
    height: 2.5,
    rx: 0.833333,
    fill: "#ACAAB7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3417 8.57625L21.937 10.1715L16.4456 15.6634C16.2193 15.8898 15.8566 15.8898 15.6303 15.6634L14.8504 14.8836C14.6241 14.6573 14.6241 14.2946 14.8504 14.0682L20.3417 8.57625ZM24.0316 7.26549L23.2476 6.48151C23.0254 6.25931 22.6586 6.25931 22.4364 6.48151L20.6148 8.3031L22.2142 9.89472L24.0315 8.07738C24.2543 7.85456 24.2544 7.48771 24.0316 7.26549ZM20.3849 2.56876L20.2077 3.14356C20.0614 3.6188 19.6892 3.99093 19.214 4.13731L18.6392 4.31449C18.5474 4.34293 18.5474 4.4733 18.6392 4.50116L19.214 4.67834C19.6892 4.8247 20.0614 5.19684 20.2077 5.67208L20.3849 6.24688C20.4134 6.33873 20.5437 6.33873 20.5716 6.24688L20.7488 5.67208C20.8951 5.19684 21.2673 4.82471 21.7425 4.67834L22.3173 4.50116C22.4092 4.47271 22.4092 4.34234 22.3173 4.31449L21.7425 4.13731C21.2673 3.99094 20.8952 3.6188 20.7488 3.14356L20.5716 2.56876C20.5437 2.47692 20.4134 2.47692 20.3849 2.56876ZM24.6686 9.81887L24.5601 10.1697C24.4707 10.46 24.2437 10.687 23.9534 10.7765L23.6025 10.8849C23.5463 10.9021 23.5463 10.9815 23.6025 10.9993L23.9534 11.1077C24.2437 11.1972 24.4707 11.4241 24.5601 11.7145L24.6686 12.0653C24.6858 12.1216 24.7652 12.1216 24.7829 12.0653L24.8914 11.7145C24.9809 11.4241 25.2078 11.1972 25.4982 11.1077L25.849 10.9993C25.9053 10.9821 25.9053 10.9027 25.849 10.8849L25.4982 10.7765C25.2078 10.687 24.9809 10.46 24.8914 10.1697L24.7829 9.81887C24.7652 9.76317 24.6858 9.76317 24.6686 9.81887ZM26.8148 6.36835L26.6803 6.80448C26.5689 7.16476 26.2868 7.44683 25.9265 7.55824L25.4904 7.69275C25.4205 7.71408 25.4205 7.81304 25.4904 7.83437L25.9265 7.96889C26.2868 8.08029 26.5689 8.36236 26.6803 8.72265L26.8148 9.15878C26.8361 9.2287 26.9351 9.2287 26.9564 9.15878L27.0909 8.72265C27.2023 8.36236 27.4844 8.0803 27.8447 7.96889L28.2808 7.83437C28.3508 7.81304 28.3508 7.71408 28.2808 7.69275L27.8447 7.55824C27.4844 7.44683 27.2024 7.16476 27.0909 6.80448L26.9564 6.36835C26.9351 6.29842 26.8361 6.29842 26.8148 6.36835Z",
    fill: "#ACAAB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutline3);
export default __webpack_public_path__ + "static/media/Outline_3.5b156f3312568fe23ba857359eab1b08.svg";
export { ForwardRef as ReactComponent };